import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

export function MsalInstanceFactory() : IPublicClientApplication {
    let instance = new PublicClientApplication({
        auth: {
            clientId: environment.azure.clientId,
            authority: environment.azure.authority,
            redirectUri: environment.azure.redirectUrl,
          },
          cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: false
          }
    });
    instance.initialize();

    return instance;
}